/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { Inject, Injector, Component, OnInit } from "@angular/core";
import { LoginViewBaseComponent } from "./login.view.base.component";
import { TranslationsProvider } from "../../../core/translations.provider";
import { SessionStorageService } from "../../../core/session-storage.service";
import { ScreenSizeService } from "../../../shared/services/screen-size.service";

const SIGNIN_STATE_KEY = "auth.signin.state";

const LOGIN_FORM = "login";
const FORGOT_PASSWORD_FORM = "forgotpass";
const RESET_PASSWORD_FORM = "resetpassword";
const ACCOUNT_ACTIVATION = "activation";

// const url = `${environment.getDataProviders()["SupplierAppProvider"].serviceUri}`;

@Component({
    templateUrl: "./login.view.component.extend.html",
    styleUrls: ["./login.view.component.css"],
})
export class LoginViewComponent extends LoginViewBaseComponent {
    private translationProvider: TranslationsProvider;
    private form: string;
    private isMobile: boolean = false;
    public urlKey: string;
    public action: string;

    private sessionStorageService: SessionStorageService;
    private screenSizeService: ScreenSizeService;

    get loginForm() {
        return this.form === LOGIN_FORM;
    }

    get forgotPasswordForm() {
        return this.form === FORGOT_PASSWORD_FORM;
    }

    get resetPasswordForm() {
        return this.form === RESET_PASSWORD_FORM;
    }

    get activation() {
        return this.form === ACCOUNT_ACTIVATION;
    }

    constructor(@Inject(Injector) injector: Injector) {
        super(injector);
        this.sessionStorageService = injector.get(SessionStorageService);
        this.screenSizeService = injector.get(ScreenSizeService);
        this.translationProvider = injector.get(TranslationsProvider);
        this.translationProvider.useDefaultLanguage();
    }

    // Fired when component is initialized and input properties are set
    public onInit(): void {
        // Set the form based on the returned url
        this.form = this.checkReturnUrl();
        this.isMobile = this.screenSizeService.isMobile;
        this.screenSizeService.isMobile$.subscribe(
            (response) => (this.isMobile = response)
        );
    }
    // Fired when component's views and child views are initialized
    public onShow(): void {}
    //Fired just before Angular destroys the component. Unsubscribe Observables and detach event handlers to avoid memory leaks
    public onHide(): void {}

    public forgotPassord(): void {
        this.form = FORGOT_PASSWORD_FORM;
    }

    private checkReturnUrl(): string {
        const signInState = this.$authenticationService.getSigninState();
        const querySeparatorIndex = signInState.returnUrl.indexOf("?");

        const urlPath = signInState.returnUrl.substring(0, querySeparatorIndex);
        const queryParams = this.parseQueryParams(
            signInState.returnUrl.substring(querySeparatorIndex + 1)
        );

        this.urlKey = queryParams["urlkey"];
        this.action = queryParams["action"];

        if (!(urlPath === "/" && !this.isNullOrEmpty(this.urlKey)))
            return "login";

        // remove urlkey from return url
        delete queryParams["action"];
        delete queryParams["urlkey"];

        signInState.returnUrl =
            Object.keys(queryParams).length > 0
                ? `${urlPath}?${this.parseQuery(queryParams)}`
                : urlPath;

        this.sessionStorageService.setItem(SIGNIN_STATE_KEY, signInState);

        return this.action;
    }

    private isNullOrEmpty(string): boolean {
        return string === null || string === undefined || string === "";
    }

    private parseQueryParams(queryString) {
        const queryParams = {};

        queryString.split("&").forEach((queryEntry) => {
            const keyValueSeparatorIndex = queryEntry.indexOf("=");

            const key = queryEntry.substring(0, keyValueSeparatorIndex);
            const value = queryEntry.substring(keyValueSeparatorIndex + 1);

            queryParams[key] = value;
        });
        return queryParams;
    }

    private parseQuery(queryParams): string {
        return Object.entries(queryParams)
            .map(([key, value]) => `${key}=${value}`)
            .join("&");
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/login/login.view.component.ts